import React from 'react';
import { Button, Input, Modal, Space, Table } from 'antd';

const LandingPickerModal = ({
  open,
  onCancel,
  keyword,
  onKeywordChange,
  onSearch,
  loading,
  items,
  onSelect,
}) => {
  return (
    <Modal
      title="Chọn Landing Page"
      open={open}
      onCancel={onCancel}
      footer={null}
      width={860}
    >
      <Space direction="vertical" style={{ width: '100%' }} size={12}>
        <Input.Search
          allowClear
          placeholder="Tìm theo tiêu đề hoặc slug"
          value={keyword}
          onChange={(e) => onKeywordChange(e.target.value)}
          onSearch={onSearch}
        />

        <Table
          rowKey="id"
          loading={loading}
          pagination={false}
          dataSource={items}
          columns={[
            {
              title: 'Tiêu đề',
              dataIndex: 'title',
              render: (_, record) => record?.title || '(Chưa đặt tiêu đề)',
            },
            {
              title: 'Slug',
              dataIndex: 'slug',
              width: 220,
              render: (slug) => (slug ? `/blog/${slug}` : '-'),
            },
            {
              title: 'Thao tác',
              key: 'action',
              width: 120,
              render: (_, record) => (
                <Button type="primary" onClick={() => onSelect(record)}>
                  Chọn
                </Button>
              ),
            },
          ]}
        />
      </Space>
    </Modal>
  );
};

export default LandingPickerModal;
